import styled, { css } from 'styled-components';

import { ReactComponent as Key } from 'assets/icons/key.svg';
import { ReactComponent as User } from 'assets/icons/user.svg';
import { device } from 'config/device';

const svgStyle = css`
  height: 2rem;
  width: 2rem;
  fill: ${(props) => props.theme.gray2};
`;

const svgPosition = css`
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-40%);
`;
export const KeyIcon = styled(Key)`
  ${svgStyle}
  ${svgPosition}
`;
export const UserIcon = styled(User)`
  ${svgStyle}
  ${svgPosition}
`;
export const LoginContainer = styled.div`
  width: 100rem;
  height: 50rem;
  min-height: 50rem;
  max-width: 97%;
  margin: 6rem auto;
  display: flex;
  overflow: hidden;
  border-radius: 5px;
  box-shadow: ${(props) => props.theme.shadow[3]};
  @media ${device.tablet} {
    width: 50rem;
  }
  @media ${device.mobile} {
    height: auto;
    margin: 2rem auto;
  }
`;

export const FormMessage = styled.p`
  font-weight: 700;
  font-size: ${(props) => props.theme.x_large};
  position: relative;
  margin-bottom: 3rem;
  :after {
    content: '';
    position: absolute;
    width: 5rem;
    height: 0.5rem;
    border-radius: 20px;
    bottom: -1.5rem;
    right: 50%;
    transform: translateX(50%);
  }
  position: relative;
  text-align: center;
  &:after {
    content: '';
    position: absolute;
    width: 5rem;
    height: 0.5rem;
    background: rgb(15, 27, 43);
    border-radius: 20px;
    right: 50%;
    transform: translateX(50%);
    bottom: -1.5rem;
  }
`;

type FormProps = {
  resize?: boolean;
};

export const Form = styled.form<FormProps>`
  width: ${(props) => (props.resize ? '100%' : '50%')};
  height: 100%;
  padding: 4rem;
  position: relative;
  gap: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  .option {
    gap: 1rem;
    display: flex;
    svg {
      fill: ${(props) => props.theme.special};
    }
  }
  h2 {
    width: 100%;
    text-align: center;
    color: ${(props) => props.theme.special};
  }
  @media ${device.mobile} {
    min-height: 50rem;
    padding: 2rem;
    gap: 4rem;
    justify-content: center;
  }
`;

export const LoginWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: ${(props) => props.theme.loginBackgroundColor};
  background-image: url(${(props) => props.theme.loginBackground});
  background-size: ${(props) => props.theme.loginBackgroundSize};
  background-position: ${(props) => props.theme.loginBackgroundPosition};
  background-repeat: no-repeat;

  @media ${device.laptop} {
    background-color: rgb(255 255 255 / 60%);
    background-blend-mode: lighten;
  }

  .leftContainer {
    flex: ${(props) => (props.theme.loginGifPath ? '1' : '1.5')};
    display: ${(props) => (props.theme.loginBackground ? 'flex' : 'none')};
    align-items: flex-start;
    flex-direction: column;
    position: relative;

    h3 {
      font-size: 6rem;
      font-weight: 300;
      margin-left: 8rem;
      margin-top: 8rem;
    }

    @media ${device.laptop} {
      flex: 1;
    }
    @media ${device.tablet} {
      flex: 0;
      display: none;
    }

    .loginImage {
      max-width: 1300px;
      @media ${device.lDesktop} {
        max-width: 70%;
      }
      img {
        width: 100%;
      }
    }
  }
  .rightContainer {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    .rightContentWrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      gap: 2rem;

      @media ${device.mobile} {
        flex-direction: column;
        gap: 1rem;
      }

      .loginGifContainer {
        display: flex;
        align-items: center;
        justify-content: center;

        .loginGif {
          max-width: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
          max-height: var(--desktop-size);

          @media ${device.mobile} {
            max-height: var(--mobile-size);
          }
        }
      }
    }

    .loginForm {
      max-width: 500px;
      height: initial;
      flex: 1;

      h3 {
        font-size: ${(props) => props.theme.x_large};
        margin-bottom: 6px;
      }
      h4 {
        font-weight: normal;
      }

      input {
        box-shadow: none;
        background-color: transparent;
        box-shadow: 0 2px ${(props) => props.theme.special};
        border-radius: 0;
      }
    }
    .branchForm {
      justify-content: center;
      max-width: 500px;

      div {
        border-radius: 8px;
      }
    }
    .loadingForm {
      height: initial;
      .notificationLoading {
        position: initial;
        top: 50%;
        transform: none;
      }
    }
    .footerContainer {
      position: absolute;
    }
  }
`;
export const ParticlesContainer = styled.div`
  width: 50%;
  height: 100%;
  color: #fff;
  position: relative;
  background: ${({ theme }) =>
    `linear-gradient(to top right, ${theme.special}FF, ${theme.special}FF, ${theme.special}CC, ${theme.special}B3)`};
`;

export const LoginError = styled.span`
  color: ${({ theme }) => theme.error};
  text-align: center;
`;

type LogoProps = {
  $logoHeight: string;
};

export const Logo = styled.img<LogoProps>`
  flex-shrink: 0;
  cursor: pointer;
  height: ${({ $logoHeight }) => $logoHeight};
  max-width: 100%;
  width: auto;
  object-fit: contain;
  margin-bottom: 2rem;
  @media ${device.mobile} {
    display: none;
  }
`;
